// Permisos del módulo Construcción. Reutiliza los roles existentes del ERP:
// field_technician, project_manager y contract_manager son los dueños naturales
// de la obra; el resto ve o aprueba según su función.

const ALL_VIEWERS = [
  'super_user',
  'project_director',
  'area_manager',
  'project_manager',
  'field_technician',
  'contract_manager',
  'purchasing_manager',
  'purchase_controller',
  'abogado',
  'office_staff'
];

// Quién puede VER cada submódulo.
export const PAGE_VIEW_ROLES = {
  'construction-schedule': ALL_VIEWERS,
  'construction-progress': ALL_VIEWERS,
  'construction-costs': ['super_user', 'project_director', 'area_manager', 'project_manager', 'contract_manager', 'purchasing_manager', 'purchase_controller'],
  'construction-daily': ['super_user', 'project_director', 'area_manager', 'project_manager', 'field_technician', 'contract_manager', 'office_staff'],
  'construction-materials': ['super_user', 'project_director', 'area_manager', 'project_manager', 'field_technician', 'purchasing_manager', 'purchase_controller'],
  'construction-contracts': ['super_user', 'project_director', 'area_manager', 'project_manager', 'contract_manager', 'purchasing_manager', 'purchase_controller', 'abogado', 'office_staff'],
  'construction-quality': ['super_user', 'project_director', 'area_manager', 'project_manager', 'field_technician', 'contract_manager', 'office_staff']
};

// Quién puede EJECUTAR cada acción.
export const ACTION_ROLES = {
  'schedule.edit': ['super_user', 'project_director', 'project_manager'],
  'progress.register': ['super_user', 'project_manager', 'field_technician'],
  'progress.approve': ['super_user', 'project_director', 'project_manager'],
  'costs.editBudget': ['super_user', 'project_director', 'project_manager'],
  'daily.edit': ['super_user', 'project_manager', 'field_technician'],
  'materials.edit': ['super_user', 'project_manager', 'field_technician'],
  'contracts.edit': ['super_user', 'contract_manager'],
  'payments.create': ['super_user', 'contract_manager'],
  'payments.approvePm': ['super_user', 'project_manager'],
  'payments.approveDirector': ['super_user', 'project_director'],
  'payments.markPaid': ['super_user', 'contract_manager', 'purchasing_manager'],
  'quality.edit': ['super_user', 'project_manager', 'field_technician'],
  'quality.closeNc': ['super_user', 'project_manager'],
  'commissioning.edit': ['super_user', 'project_manager', 'field_technician']
};

export const canViewConstructionPage = (role, pageId) => {
  const roles = PAGE_VIEW_ROLES[pageId];
  return Boolean(roles && roles.includes(role));
};

export const canDo = (role, action) => Boolean(ACTION_ROLES[action]?.includes(role));
